export default __webpack_public_path__ + "static/media/manual-de-boas-praticas-mario-bezerra.3ec24cd9.pdf";